var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c(
        "div",
        { staticClass: "filter-container" },
        [
          _vm._v(" " + _vm._s(_vm.$t("table.isPremium")) + "： "),
          _c(
            "el-select",
            {
              staticClass: "filter-item",
              staticStyle: { width: "130px" },
              attrs: { placeholder: _vm.$t("table.isPremium"), clearable: "" },
              model: {
                value: _vm.listQuery.isPremium,
                callback: function ($$v) {
                  _vm.$set(_vm.listQuery, "isPremium", $$v)
                },
                expression: "listQuery.isPremium",
              },
            },
            _vm._l(_vm.boolTypeOptions, function (item) {
              return _c("el-option", {
                key: item.key,
                attrs: { label: item.displayName, value: item.key },
              })
            }),
            1
          ),
          _vm._v(" " + _vm._s(_vm.$t("table.isAssistant")) + "： "),
          _c(
            "el-select",
            {
              staticClass: "filter-item",
              staticStyle: { width: "130px" },
              attrs: {
                placeholder: _vm.$t("table.isAssistant"),
                clearable: "",
              },
              model: {
                value: _vm.listQuery.isAssistant,
                callback: function ($$v) {
                  _vm.$set(_vm.listQuery, "isAssistant", $$v)
                },
                expression: "listQuery.isAssistant",
              },
            },
            _vm._l(_vm.boolTypeOptions, function (item) {
              return _c("el-option", {
                key: item.key,
                attrs: { label: item.displayName, value: item.key },
              })
            }),
            1
          ),
          _vm._v(" " + _vm._s(_vm.$t("table.loginType")) + "： "),
          _c(
            "el-select",
            {
              staticClass: "filter-item",
              staticStyle: { width: "130px" },
              attrs: { placeholder: _vm.$t("table.loginType"), clearable: "" },
              model: {
                value: _vm.listQuery.loginType,
                callback: function ($$v) {
                  _vm.$set(_vm.listQuery, "loginType", $$v)
                },
                expression: "listQuery.loginType",
              },
            },
            _vm._l(_vm.loginTypeOptions, function (item) {
              return _c("el-option", {
                key: item.key,
                attrs: { label: item.displayName, value: item.key },
              })
            }),
            1
          ),
          _vm._v(" User Type： "),
          _c(
            "el-select",
            {
              staticClass: "filter-item",
              staticStyle: { width: "130px" },
              attrs: { placeholder: "User Type", clearable: "" },
              model: {
                value: _vm.listQuery.userType,
                callback: function ($$v) {
                  _vm.$set(_vm.listQuery, "userType", $$v)
                },
                expression: "listQuery.userType",
              },
            },
            _vm._l(_vm.userTypeOptions, function (item) {
              return _c("el-option", {
                key: item.key,
                attrs: { label: item.displayName, value: item.key },
              })
            }),
            1
          ),
          _vm._v(" OS： "),
          _c(
            "el-select",
            {
              staticClass: "filter-item",
              staticStyle: { width: "120px" },
              attrs: { placeholder: "OS", clearable: "" },
              model: {
                value: _vm.listQuery.platform,
                callback: function ($$v) {
                  _vm.$set(_vm.listQuery, "platform", $$v)
                },
                expression: "listQuery.platform",
              },
            },
            [
              _c("el-option", { attrs: { label: "iOS", value: "ios" } }),
              _c("el-option", {
                attrs: { label: "Android", value: "android" },
              }),
              _c("el-option", {
                attrs: { label: "Unknown", value: "unknown" },
              }),
            ],
            1
          ),
          _c("br"),
          _c("el-input", {
            staticClass: "filter-item",
            staticStyle: { width: "200px" },
            attrs: { placeholder: _vm.$t("table.search") },
            nativeOn: {
              keyup: function ($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                )
                  return null
                return _vm.handleFilter.apply(null, arguments)
              },
            },
            model: {
              value: _vm.listQuery.text,
              callback: function ($$v) {
                _vm.$set(_vm.listQuery, "text", $$v)
              },
              expression: "listQuery.text",
            },
          }),
          _c("br"),
          _c(
            "el-button",
            {
              directives: [{ name: "waves", rawName: "v-waves" }],
              staticClass: "filter-item",
              attrs: { type: "primary", icon: "el-icon-search" },
              on: { click: _vm.handleFilter },
            },
            [_vm._v(" " + _vm._s(_vm.$t("table.search")) + " ")]
          ),
        ],
        1
      ),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.listLoading,
              expression: "listLoading",
            },
          ],
          attrs: {
            data: _vm.list,
            "element-loading-text": "Loading...",
            border: "",
            fit: "",
            "highlight-current-row": "",
          },
        },
        [
          _c("el-table-column", {
            attrs: { align: "center", label: "No", width: "95" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ $index }) {
                  return [
                    _vm._v(
                      " " +
                        _vm._s(
                          (_vm.listQuery.page - 1) * _vm.listQuery.limit +
                            $index +
                            1
                        ) +
                        " "
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "First Name" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [_vm._v(" " + _vm._s(row.firstName) + " ")]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "Last Name", align: "center", width: "180" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [_vm._v(" " + _vm._s(row.lastName) + " ")]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "Email", align: "center", width: "115" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [_vm._v(" " + _vm._s(row.email) + " ")]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "Login Type", align: "center", width: "115" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [_vm._v(" " + _vm._s(row.loginType) + " ")]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "OS", align: "center", width: "90" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    row.lastKnownPlatform
                      ? _c(
                          "el-tooltip",
                          {
                            attrs: {
                              content:
                                "Last seen: " +
                                _vm.formatDate(row.lastPlatformSeenAt),
                              placement: "top",
                            },
                          },
                          [
                            _c(
                              "el-tag",
                              {
                                attrs: {
                                  type:
                                    row.lastKnownPlatform === "ios"
                                      ? ""
                                      : "success",
                                  size: "mini",
                                },
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      row.lastKnownPlatform === "ios"
                                        ? "iOS"
                                        : "Android"
                                    ) +
                                    " "
                                ),
                              ]
                            ),
                          ],
                          1
                        )
                      : _c("span", { staticStyle: { color: "#c0c4cc" } }, [
                          _vm._v("-"),
                        ]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "User Type", align: "center", width: "100" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    row.userType
                      ? _c(
                          "el-tag",
                          {
                            attrs: {
                              type:
                                row.userType === "admin"
                                  ? "danger"
                                  : row.userType === "trainer"
                                  ? "warning"
                                  : "info",
                              size: "mini",
                            },
                          },
                          [_vm._v(" " + _vm._s(row.userType) + " ")]
                        )
                      : _c("span", { staticStyle: { color: "#c0c4cc" } }, [
                          _vm._v("-"),
                        ]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "Date of Entry", align: "center", width: "220" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    _c("i", { staticClass: "el-icon-time" }),
                    _c("span", [_vm._v(_vm._s(row.dateOfEntry))]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("table.actions"),
              align: "center",
              width: "400",
              "class-name": "fixed-width",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary", size: "mini" },
                        on: {
                          click: function ($event) {
                            return _vm.handleUpdate(row)
                          },
                        },
                      },
                      [_vm._v(" " + _vm._s(_vm.$t("table.edit")) + " ")]
                    ),
                    row.canUseConsult !== true
                      ? _c(
                          "el-button",
                          {
                            attrs: { size: "mini", type: "success" },
                            on: {
                              click: function ($event) {
                                return _vm.handleToggleCanUseConsult(
                                  row,
                                  row.userId
                                )
                              },
                            },
                          },
                          [
                            _vm._v(
                              " " + _vm._s(_vm.$t("table.enableConsult")) + " "
                            ),
                          ]
                        )
                      : row.canUseConsult === true
                      ? _c(
                          "el-button",
                          {
                            attrs: { size: "mini", type: "danger" },
                            on: {
                              click: function ($event) {
                                return _vm.handleToggleCanUseConsult(
                                  row,
                                  row.userId
                                )
                              },
                            },
                          },
                          [
                            _vm._v(
                              " " + _vm._s(_vm.$t("table.disableConsult")) + " "
                            ),
                          ]
                        )
                      : _vm._e(),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _c("el-pagination", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.total > 0,
            expression: "total > 0",
          },
        ],
        staticStyle: { "margin-top": "20px", "text-align": "right" },
        attrs: {
          "current-page": _vm.listQuery.page,
          "page-sizes": [10, 20, 30, 50, 100],
          "page-size": _vm.listQuery.limit,
          total: _vm.total,
          background: "",
          layout: "total, sizes, prev, pager, next, jumper",
        },
        on: {
          "size-change": _vm.handleSizeChange,
          "current-change": _vm.handleCurrentChange,
        },
      }),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.textMap[_vm.dialogStatus],
            visible: _vm.dialogFormVisible,
            width: "1100px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogFormVisible = $event
            },
            open: _vm.onDialogOpen,
          },
        },
        [
          _c(
            "el-tabs",
            {
              on: { "tab-click": _vm.handleTabClick },
              model: {
                value: _vm.activeTab,
                callback: function ($$v) {
                  _vm.activeTab = $$v
                },
                expression: "activeTab",
              },
            },
            [
              _c(
                "el-tab-pane",
                { attrs: { label: "Basic Information", name: "basic" } },
                [
                  _c(
                    "el-form",
                    {
                      ref: "dataForm",
                      attrs: {
                        rules: _vm.rules,
                        model: _vm.tempUserData,
                        "label-position": "left",
                        "label-width": "150px",
                      },
                    },
                    [
                      _c(
                        "el-row",
                        { attrs: { gutter: 20 } },
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("columnType.firstName"),
                                    prop: "firstName",
                                  },
                                },
                                [
                                  _c("el-input", {
                                    attrs: { placeholder: "First name" },
                                    model: {
                                      value: _vm.tempUserData.firstName,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.tempUserData,
                                          "firstName",
                                          $$v
                                        )
                                      },
                                      expression: "tempUserData.firstName",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("columnType.lastName"),
                                    prop: "lastName",
                                  },
                                },
                                [
                                  _c("el-input", {
                                    attrs: { placeholder: "Last name" },
                                    model: {
                                      value: _vm.tempUserData.lastName,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.tempUserData,
                                          "lastName",
                                          $$v
                                        )
                                      },
                                      expression: "tempUserData.lastName",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-row",
                        { attrs: { gutter: 20 } },
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 24 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("columnType.email"),
                                    prop: "email",
                                  },
                                },
                                [
                                  _c("el-input", {
                                    attrs: { placeholder: "Email" },
                                    model: {
                                      value: _vm.tempUserData.email,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.tempUserData, "email", $$v)
                                      },
                                      expression: "tempUserData.email",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-row",
                        { attrs: { gutter: 20 } },
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 8 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("columnType.countryCode"),
                                  },
                                },
                                [
                                  _c("el-input", {
                                    attrs: { placeholder: "+90" },
                                    model: {
                                      value: _vm.tempUserData.countryCode,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.tempUserData,
                                          "countryCode",
                                          $$v
                                        )
                                      },
                                      expression: "tempUserData.countryCode",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 16 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("columnType.phoneNumber"),
                                  },
                                },
                                [
                                  _c("el-input", {
                                    attrs: { placeholder: "Phone" },
                                    model: {
                                      value: _vm.tempUserData.phoneNumber,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.tempUserData,
                                          "phoneNumber",
                                          $$v
                                        )
                                      },
                                      expression: "tempUserData.phoneNumber",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-row",
                        { attrs: { gutter: 20 } },
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("columnType.country"),
                                  },
                                },
                                [
                                  _c("el-input", {
                                    attrs: { placeholder: "Country" },
                                    model: {
                                      value: _vm.tempUserData.country,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.tempUserData,
                                          "country",
                                          $$v
                                        )
                                      },
                                      expression: "tempUserData.country",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c(
                                "el-form-item",
                                { attrs: { label: _vm.$t("columnType.city") } },
                                [
                                  _c("el-input", {
                                    attrs: { placeholder: "City" },
                                    model: {
                                      value: _vm.tempUserData.city,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.tempUserData, "city", $$v)
                                      },
                                      expression: "tempUserData.city",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-tab-pane",
                { attrs: { label: "Account Settings", name: "settings" } },
                [
                  _c(
                    "el-form",
                    {
                      attrs: {
                        model: _vm.tempUserData,
                        "label-position": "left",
                        "label-width": "150px",
                      },
                    },
                    [
                      _c(
                        "el-row",
                        { attrs: { gutter: 20 } },
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("columnType.userType"),
                                  },
                                },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      staticStyle: { width: "100%" },
                                      attrs: {
                                        placeholder: "Select User Type",
                                      },
                                      model: {
                                        value: _vm.tempUserData.userType,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.tempUserData,
                                            "userType",
                                            $$v
                                          )
                                        },
                                        expression: "tempUserData.userType",
                                      },
                                    },
                                    [
                                      _c("el-option", {
                                        attrs: { label: "User", value: "user" },
                                      }),
                                      _c("el-option", {
                                        attrs: {
                                          label: "Admin",
                                          value: "admin",
                                        },
                                      }),
                                      _c("el-option", {
                                        attrs: {
                                          label: "Trainer",
                                          value: "trainer",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c(
                                "el-form-item",
                                { attrs: { label: "Device" } },
                                [
                                  _vm.userDeviceData
                                    ? _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            "line-height": "36px",
                                          },
                                        },
                                        [
                                          _c(
                                            "a",
                                            {
                                              staticStyle: {
                                                "font-family": "monospace",
                                                cursor: "pointer",
                                              },
                                              on: {
                                                click:
                                                  _vm.openDeviceDetailFromUser,
                                              },
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.userDeviceDisplay
                                                  ) +
                                                  " "
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "el-tag",
                                            {
                                              staticStyle: {
                                                "margin-left": "8px",
                                              },
                                              attrs: {
                                                type: _vm.userDeviceLifecycleTag,
                                                size: "mini",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.userDeviceLifecycle
                                                  ) +
                                                  " "
                                              ),
                                            ]
                                          ),
                                          _vm.userDeviceActivationPending
                                            ? _c(
                                                "el-tag",
                                                {
                                                  staticStyle: {
                                                    "margin-left": "4px",
                                                  },
                                                  attrs: {
                                                    type: "warning",
                                                    size: "mini",
                                                    title:
                                                      "Cane activation flow started but never completed — user pressed pair but never confirmed.",
                                                  },
                                                },
                                                [_vm._v(" Activation Pending ")]
                                              )
                                            : _vm._e(),
                                        ],
                                        1
                                      )
                                    : _c("el-input", {
                                        attrs: {
                                          value: "-",
                                          disabled: "",
                                          placeholder: "No device connected",
                                        },
                                      }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-row",
                        { attrs: { gutter: 20 } },
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("columnType.assistant"),
                                  },
                                },
                                [
                                  _c("el-switch", {
                                    attrs: {
                                      "active-text": _vm.$t("Yes"),
                                      "inactive-text": _vm.$t("No"),
                                    },
                                    model: {
                                      value: _vm.tempUserData.isAssistant,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.tempUserData,
                                          "isAssistant",
                                          $$v
                                        )
                                      },
                                      expression: "tempUserData.isAssistant",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("columnType.isPremium"),
                                  },
                                },
                                [
                                  _c("el-switch", {
                                    attrs: {
                                      "active-text": _vm.$t("Yes"),
                                      "inactive-text": _vm.$t("No"),
                                    },
                                    model: {
                                      value: _vm.tempUserData.isPremium,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.tempUserData,
                                          "isPremium",
                                          $$v
                                        )
                                      },
                                      expression: "tempUserData.isPremium",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm.tempUserData.isAssistant
                        ? _c(
                            "el-row",
                            { attrs: { gutter: 20 } },
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 24 } },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: _vm.$t(
                                          "columnType.assistantRegion"
                                        ),
                                      },
                                    },
                                    [
                                      _c(
                                        "el-select",
                                        {
                                          staticStyle: { width: "100%" },
                                          attrs: { multiple: "" },
                                          model: {
                                            value:
                                              _vm.tempUserData.assistantRegion,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.tempUserData,
                                                "assistantRegion",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "tempUserData.assistantRegion",
                                          },
                                        },
                                        _vm._l(
                                          _vm.applicationRegions,
                                          function (option) {
                                            return _c("el-option", {
                                              key: option,
                                              attrs: {
                                                label: option,
                                                value: option,
                                              },
                                            })
                                          }
                                        ),
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-tab-pane",
                { attrs: { label: "WeAssist", name: "consult" } },
                [
                  _c(
                    "el-form",
                    {
                      attrs: {
                        model: _vm.tempUserData,
                        "label-position": "left",
                        "label-width": "180px",
                      },
                    },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "Current Consult Time" } },
                        [
                          _c(
                            "span",
                            {
                              staticStyle: {
                                "font-size": "20px",
                                "font-weight": "600",
                                color: "#409EFF",
                              },
                            },
                            [_vm._v(_vm._s(_vm.activeConsultMinutes))]
                          ),
                          _c(
                            "span",
                            {
                              staticStyle: {
                                "margin-left": "8px",
                                color: "#909399",
                              },
                            },
                            [_vm._v("minutes")]
                          ),
                          _vm.activeConsultMinutes > 0
                            ? _c(
                                "span",
                                {
                                  staticStyle: {
                                    "margin-left": "10px",
                                    "font-size": "12px",
                                    color: "#67C23A",
                                  },
                                },
                                [
                                  _vm._v(
                                    "(" +
                                      _vm._s(_vm.activeConsultSeconds) +
                                      "s from " +
                                      _vm._s(_vm.activeConsultCount) +
                                      " active subscription" +
                                      _vm._s(
                                        _vm.activeConsultCount > 1 ? "s" : ""
                                      ) +
                                      ")"
                                  ),
                                ]
                              )
                            : _c(
                                "span",
                                {
                                  staticStyle: {
                                    "margin-left": "10px",
                                    "font-size": "12px",
                                    color: "#F56C6C",
                                  },
                                },
                                [_vm._v("No active credits")]
                              ),
                        ]
                      ),
                    ],
                    1
                  ),
                  _c("el-divider", { attrs: { "content-position": "left" } }, [
                    _vm._v("Credit History"),
                  ]),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        "margin-bottom": "10px",
                        display: "flex",
                        "align-items": "center",
                      },
                    },
                    [
                      _c("el-input", {
                        staticStyle: { width: "300px", "margin-right": "10px" },
                        attrs: {
                          placeholder:
                            "Search by transaction ID or platform...",
                          size: "small",
                          clearable: "",
                        },
                        on: { clear: _vm.fetchConsultSubscriptions },
                        nativeOn: {
                          keyup: function ($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            )
                              return null
                            return _vm.fetchConsultSubscriptions.apply(
                              null,
                              arguments
                            )
                          },
                        },
                        model: {
                          value: _vm.consultSubsSearch,
                          callback: function ($$v) {
                            _vm.consultSubsSearch = $$v
                          },
                          expression: "consultSubsSearch",
                        },
                      }),
                      _c(
                        "el-button",
                        {
                          attrs: {
                            size: "small",
                            type: "primary",
                            icon: "el-icon-search",
                          },
                          on: { click: _vm.fetchConsultSubscriptions },
                        },
                        [_vm._v("Search")]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-table",
                    {
                      directives: [
                        {
                          name: "loading",
                          rawName: "v-loading",
                          value: _vm.consultSubsLoading,
                          expression: "consultSubsLoading",
                        },
                      ],
                      staticStyle: { width: "100%" },
                      attrs: {
                        data: _vm.consultSubscriptions,
                        border: "",
                        size: "small",
                      },
                    },
                    [
                      _c("el-table-column", {
                        attrs: { type: "expand" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function ({ row }) {
                              return [
                                _c(
                                  "div",
                                  { staticStyle: { padding: "8px 20px" } },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticStyle: { "margin-bottom": "8px" },
                                      },
                                      [
                                        _c(
                                          "el-tag",
                                          {
                                            attrs: {
                                              size: "mini",
                                              type: "info",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "userDialog.consultGranted",
                                                  {
                                                    min: Math.round(
                                                      (row.grantedSeconds ||
                                                        0) / 60
                                                    ),
                                                    sec:
                                                      row.grantedSeconds || 0,
                                                  }
                                                )
                                              )
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "el-tag",
                                          {
                                            staticStyle: {
                                              "margin-left": "6px",
                                            },
                                            attrs: {
                                              size: "mini",
                                              type: "danger",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "userDialog.consultUsed",
                                                  {
                                                    min: Math.round(
                                                      (row.usedSeconds || 0) /
                                                        60
                                                    ),
                                                    sec: row.usedSeconds || 0,
                                                  }
                                                )
                                              )
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "el-tag",
                                          {
                                            staticStyle: {
                                              "margin-left": "6px",
                                            },
                                            attrs: {
                                              size: "mini",
                                              type: "success",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "userDialog.consultRemaining",
                                                  {
                                                    min: Math.round(
                                                      (row.duration || 0) / 60
                                                    ),
                                                    sec: row.duration || 0,
                                                  }
                                                )
                                              )
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                    row.deductions && row.deductions.length
                                      ? _c(
                                          "el-table",
                                          {
                                            attrs: {
                                              data: row.deductions,
                                              size: "mini",
                                              border: "",
                                            },
                                          },
                                          [
                                            _c("el-table-column", {
                                              attrs: {
                                                label: _vm.$t(
                                                  "userDialog.callDate"
                                                ),
                                                width: "160",
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "default",
                                                    fn: function (d) {
                                                      return [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.formatDate(
                                                              d.row.callStart ||
                                                                d.row.at
                                                            )
                                                          )
                                                        ),
                                                      ]
                                                    },
                                                  },
                                                ],
                                                null,
                                                true
                                              ),
                                            }),
                                            _c("el-table-column", {
                                              attrs: {
                                                label: _vm.$t(
                                                  "userDialog.callDuration"
                                                ),
                                                width: "130",
                                                align: "center",
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "default",
                                                    fn: function (d) {
                                                      return [
                                                        _vm._v(
                                                          _vm._s(
                                                            Math.round(
                                                              (d.row
                                                                .callDuration ||
                                                                0) / 60
                                                            )
                                                          ) +
                                                            " " +
                                                            _vm._s(
                                                              _vm.$t(
                                                                "userDialog.minShort"
                                                              )
                                                            ) +
                                                            " "
                                                        ),
                                                        _c(
                                                          "span",
                                                          {
                                                            staticStyle: {
                                                              color: "#909399",
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              "(" +
                                                                _vm._s(
                                                                  d.row
                                                                    .callDuration ||
                                                                    0
                                                                ) +
                                                                "s)"
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    },
                                                  },
                                                ],
                                                null,
                                                true
                                              ),
                                            }),
                                            _c("el-table-column", {
                                              attrs: {
                                                label: _vm.$t(
                                                  "userDialog.deductedFromPackage"
                                                ),
                                                width: "160",
                                                align: "center",
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "default",
                                                    fn: function (d) {
                                                      return [
                                                        _c("strong", [
                                                          _vm._v(
                                                            _vm._s(
                                                              Math.round(
                                                                (d.row
                                                                  .deductedSeconds ||
                                                                  0) / 60
                                                              )
                                                            ) +
                                                              " " +
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "userDialog.minShort"
                                                                )
                                                              )
                                                          ),
                                                        ]),
                                                        _vm._v(" "),
                                                        _c(
                                                          "span",
                                                          {
                                                            staticStyle: {
                                                              color: "#909399",
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              "(" +
                                                                _vm._s(
                                                                  d.row
                                                                    .deductedSeconds ||
                                                                    0
                                                                ) +
                                                                "s)"
                                                            ),
                                                          ]
                                                        ),
                                                        d.row.isOverflow
                                                          ? _c(
                                                              "el-tag",
                                                              {
                                                                staticStyle: {
                                                                  "margin-left":
                                                                    "4px",
                                                                },
                                                                attrs: {
                                                                  type: "danger",
                                                                  size: "mini",
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.$t(
                                                                      "userDialog.overflow"
                                                                    )
                                                                  )
                                                                ),
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                      ]
                                                    },
                                                  },
                                                ],
                                                null,
                                                true
                                              ),
                                            }),
                                            _c("el-table-column", {
                                              attrs: {
                                                label: "Status",
                                                width: "110",
                                                align: "center",
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "default",
                                                    fn: function (d) {
                                                      return [
                                                        _vm._v(
                                                          _vm._s(
                                                            d.row.callStatus ||
                                                              "-"
                                                          )
                                                        ),
                                                      ]
                                                    },
                                                  },
                                                ],
                                                null,
                                                true
                                              ),
                                            }),
                                            _c("el-table-column", {
                                              attrs: { label: "Session ID" },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "default",
                                                    fn: function (d) {
                                                      return [
                                                        _c(
                                                          "span",
                                                          {
                                                            staticStyle: {
                                                              "font-size":
                                                                "12px",
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                d.row.sessionId
                                                              )
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    },
                                                  },
                                                ],
                                                null,
                                                true
                                              ),
                                            }),
                                          ],
                                          1
                                        )
                                      : _c(
                                          "div",
                                          {
                                            staticStyle: {
                                              color: "#909399",
                                              "font-size": "12px",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "userDialog.noConsultDeductions"
                                                  )
                                                ) +
                                                " "
                                            ),
                                          ]
                                        ),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: "Platform",
                          width: "120",
                          align: "center",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function ({ row }) {
                              return [
                                _c(
                                  "el-tag",
                                  {
                                    attrs: {
                                      type:
                                        row.platform === "welcome-gift"
                                          ? "success"
                                          : row.platform === "coupon"
                                          ? "warning"
                                          : "primary",
                                      size: "mini",
                                    },
                                  },
                                  [_vm._v(" " + _vm._s(row.platform) + " ")]
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: _vm.$t("userDialog.remaining"),
                          width: "110",
                          align: "center",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function ({ row }) {
                              return [
                                _c("strong", [
                                  _vm._v(_vm._s(Math.round(row.duration / 60))),
                                ]),
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.$t("userDialog.minShort")) +
                                    " "
                                ),
                                _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      "font-size": "11px",
                                      color: "#909399",
                                    },
                                  },
                                  [_vm._v(_vm._s(row.duration) + "s")]
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: _vm.$t("userDialog.used"),
                          width: "110",
                          align: "center",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function ({ row }) {
                              return [
                                _c("strong", [
                                  _vm._v(
                                    _vm._s(
                                      Math.round((row.usedSeconds || 0) / 60)
                                    )
                                  ),
                                ]),
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.$t("userDialog.minShort")) +
                                    " "
                                ),
                                _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      "font-size": "11px",
                                      color: "#909399",
                                    },
                                  },
                                  [_vm._v(_vm._s(row.usedSeconds || 0) + "s")]
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                      _c("el-table-column", {
                        attrs: { label: "Expires", width: "140" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function ({ row }) {
                              return [
                                _c(
                                  "span",
                                  {
                                    style: {
                                      color:
                                        new Date(row.expiresDate) < new Date()
                                          ? "#F56C6C"
                                          : "#67C23A",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.formatDate(row.expiresDate)
                                        ) +
                                        " "
                                    ),
                                  ]
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                      _c("el-table-column", {
                        attrs: { label: "Transaction ID", "min-width": "250" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function ({ row }) {
                              return [
                                _c(
                                  "span",
                                  {
                                    staticStyle: {
                                      "font-size": "12px",
                                      "word-break": "break-all",
                                    },
                                  },
                                  [_vm._v(_vm._s(row.transactionId || "-"))]
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                      _c("el-table-column", {
                        attrs: { label: "Created", width: "140" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function ({ row }) {
                              return [
                                _vm._v(_vm._s(_vm.formatDate(row.createdAt))),
                              ]
                            },
                          },
                        ]),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: "Action",
                          width: "100",
                          align: "center",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function ({ row }) {
                              return [
                                new Date(row.expiresDate) > new Date()
                                  ? _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          size: "mini",
                                          type: "danger",
                                          icon: "el-icon-delete",
                                          loading:
                                            _vm.deletingConsultSubId === row.id,
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.handleDeleteConsultSubscription(
                                              row
                                            )
                                          },
                                        },
                                      },
                                      [_vm._v(" Delete ")]
                                    )
                                  : _c(
                                      "span",
                                      {
                                        staticStyle: {
                                          color: "#C0C4CC",
                                          "font-size": "12px",
                                        },
                                      },
                                      [_vm._v("Expired")]
                                    ),
                              ]
                            },
                          },
                        ]),
                      }),
                    ],
                    1
                  ),
                  _vm.consultSubsTotal > _vm.consultSubsLimit
                    ? _c("el-pagination", {
                        staticStyle: {
                          "margin-top": "10px",
                          "text-align": "right",
                        },
                        attrs: {
                          layout: "prev, pager, next, total",
                          total: _vm.consultSubsTotal,
                          "page-size": _vm.consultSubsLimit,
                          "current-page": _vm.consultSubsPage,
                        },
                        on: {
                          "update:currentPage": function ($event) {
                            _vm.consultSubsPage = $event
                          },
                          "update:current-page": function ($event) {
                            _vm.consultSubsPage = $event
                          },
                          "current-change": _vm.fetchConsultSubscriptions,
                        },
                      })
                    : _vm._e(),
                  _c("el-divider", { attrs: { "content-position": "left" } }, [
                    _vm._v("Add Consult Time"),
                  ]),
                  _c(
                    "el-form",
                    {
                      attrs: {
                        model: _vm.tempUserData,
                        "label-position": "left",
                        "label-width": "180px",
                      },
                    },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "Add Consult Time" } },
                        [
                          _c("el-input-number", {
                            staticStyle: { width: "120px" },
                            attrs: { min: 0, step: 5 },
                            model: {
                              value: _vm.tempUserData.addConsultMinutes,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.tempUserData,
                                  "addConsultMinutes",
                                  $$v
                                )
                              },
                              expression: "tempUserData.addConsultMinutes",
                            },
                          }),
                          _c(
                            "span",
                            {
                              staticStyle: {
                                "margin-left": "10px",
                                color: "#909399",
                              },
                            },
                            [_vm._v("minutes (0 = no change)")]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "Expires Date" } },
                        [
                          _c("el-date-picker", {
                            staticStyle: { width: "200px" },
                            attrs: {
                              type: "date",
                              placeholder: "Select expiry date",
                              "picker-options": _vm.pickerOptions,
                            },
                            model: {
                              value: _vm.tempUserData.consultExpiresDate,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.tempUserData,
                                  "consultExpiresDate",
                                  $$v
                                )
                              },
                              expression: "tempUserData.consultExpiresDate",
                            },
                          }),
                          _c(
                            "span",
                            {
                              staticStyle: {
                                "margin-left": "10px",
                                color: "#909399",
                              },
                            },
                            [_vm._v("When will this credit expire?")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-tab-pane",
                {
                  attrs: {
                    label: "Features & Entitlements",
                    name: "entitlements",
                  },
                },
                [
                  _c(
                    "div",
                    { staticStyle: { "margin-bottom": "15px" } },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: {
                            type: "primary",
                            size: "small",
                            icon: "el-icon-plus",
                          },
                          on: { click: _vm.handleGrantFeature },
                        },
                        [_vm._v(" Grant Feature ")]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-table",
                    {
                      directives: [
                        {
                          name: "loading",
                          rawName: "v-loading",
                          value: _vm.entitlementsLoading,
                          expression: "entitlementsLoading",
                        },
                      ],
                      staticStyle: { width: "100%" },
                      attrs: {
                        data: _vm.userEntitlements,
                        border: "",
                        size: "small",
                      },
                    },
                    [
                      _c("el-table-column", {
                        attrs: {
                          prop: "feature.name",
                          label: "Feature",
                          width: "150",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function ({ row }) {
                              return [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      row.feature?.name ||
                                        row.feature?.featureKey ||
                                        "N/A"
                                    ) +
                                    " "
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "sourceType",
                          label: "Source",
                          width: "120",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: { label: "Start Date", width: "110" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function ({ row }) {
                              return [
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.formatDate(row.startDate)) +
                                    " "
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                      _c("el-table-column", {
                        attrs: { label: "End Date", width: "110" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function ({ row }) {
                              return [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      row.endDate
                                        ? _vm.formatDate(row.endDate)
                                        : "Unlimited"
                                    ) +
                                    " "
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: "Status",
                          width: "90",
                          align: "center",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function ({ row }) {
                              return [
                                _c(
                                  "el-tag",
                                  {
                                    attrs: {
                                      type: _vm.getStatusType(row),
                                      size: "small",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " + _vm._s(_vm.getStatusText(row)) + " "
                                    ),
                                  ]
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: "Actions",
                          width: "150",
                          align: "center",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function ({ row }) {
                              return [
                                row.isActive && row.endDate
                                  ? _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          type: "primary",
                                          size: "mini",
                                          icon: "el-icon-time",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.handleExtendFeature(row)
                                          },
                                        },
                                      },
                                      [_vm._v(" Extend ")]
                                    )
                                  : _vm._e(),
                                row.isActive
                                  ? _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          type: "danger",
                                          size: "mini",
                                          icon: "el-icon-delete",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.handleRevokeFeature(row)
                                          },
                                        },
                                      },
                                      [_vm._v(" Revoke ")]
                                    )
                                  : _vm._e(),
                              ]
                            },
                          },
                        ]),
                      }),
                    ],
                    1
                  ),
                  _vm.userEntitlements.length === 0 && !_vm.entitlementsLoading
                    ? _c(
                        "div",
                        {
                          staticStyle: {
                            "text-align": "center",
                            padding: "20px",
                            color: "#909399",
                          },
                        },
                        [_vm._v(" No entitlements found for this user ")]
                      )
                    : _vm._e(),
                ],
                1
              ),
              _c(
                "el-tab-pane",
                { attrs: { label: "Subscriptions", name: "subscriptions" } },
                [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "loading",
                          rawName: "v-loading",
                          value: _vm.subscriptionsLoading,
                          expression: "subscriptionsLoading",
                        },
                      ],
                    },
                    [
                      _vm.subscriptionSummary
                        ? _c(
                            "div",
                            { staticStyle: { "margin-bottom": "20px" } },
                            [
                              _c(
                                "el-descriptions",
                                {
                                  attrs: {
                                    column: 3,
                                    border: "",
                                    size: "small",
                                    title: "Current Status",
                                  },
                                },
                                [
                                  _c(
                                    "el-descriptions-item",
                                    { attrs: { label: "Platform" } },
                                    [
                                      _vm.subscriptionSummary.platform
                                        ? _c(
                                            "el-tag",
                                            {
                                              attrs: {
                                                size: "small",
                                                type:
                                                  _vm.subscriptionSummary
                                                    .platform === "ios"
                                                    ? ""
                                                    : "success",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.subscriptionSummary
                                                      .platform === "ios"
                                                      ? "iOS"
                                                      : "Android"
                                                  ) +
                                                  " "
                                              ),
                                            ]
                                          )
                                        : _c(
                                            "span",
                                            {
                                              staticStyle: { color: "#909399" },
                                            },
                                            [_vm._v("N/A")]
                                          ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-descriptions-item",
                                    { attrs: { label: "Status" } },
                                    [
                                      _c(
                                        "el-tag",
                                        {
                                          attrs: {
                                            type: _vm.getSubscriptionStatusType(
                                              _vm.subscriptionSummary.status
                                            ),
                                            size: "small",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.subscriptionSummary
                                                  .status || "N/A"
                                              ) +
                                              " "
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-descriptions-item",
                                    { attrs: { label: "Auto-Renew" } },
                                    [
                                      _c(
                                        "el-tag",
                                        {
                                          attrs: {
                                            type: _vm.subscriptionSummary
                                              .autoRenew
                                              ? "success"
                                              : "danger",
                                            size: "small",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.subscriptionSummary
                                                  .autoRenew
                                                  ? "Yes"
                                                  : "No"
                                              ) +
                                              " "
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-descriptions-item",
                                    { attrs: { label: "Product" } },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.displayProduct(
                                              _vm.subscriptionSummary
                                            )
                                          ) +
                                          " "
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "el-descriptions-item",
                                    { attrs: { label: "First Purchase" } },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.subscriptionSummary
                                              .firstPurchaseDate
                                              ? _vm.formatDate(
                                                  _vm.subscriptionSummary
                                                    .firstPurchaseDate
                                                )
                                              : "N/A"
                                          ) +
                                          " "
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "el-descriptions-item",
                                    { attrs: { label: "Expires" } },
                                    [
                                      _c(
                                        "span",
                                        {
                                          style: {
                                            color: _vm.isExpiringSoon(
                                              _vm.subscriptionSummary
                                                .expiresDate
                                            )
                                              ? "#E6A23C"
                                              : "",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.subscriptionSummary
                                                  .expiresDate
                                                  ? _vm.formatDate(
                                                      _vm.subscriptionSummary
                                                        .expiresDate
                                                    )
                                                  : "N/A"
                                              ) +
                                              " "
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _c("h4", { staticStyle: { margin: "15px 0 10px" } }, [
                        _vm._v("Purchase History"),
                      ]),
                      _c(
                        "el-table",
                        {
                          staticStyle: { width: "100%" },
                          attrs: {
                            data: _vm.userTransactions,
                            border: "",
                            size: "small",
                            "default-sort": {
                              prop: "purchase_date",
                              order: "descending",
                            },
                          },
                        },
                        [
                          _c("el-table-column", {
                            attrs: {
                              label: "Date",
                              width: "100",
                              prop: "purchase_date",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function ({ row }) {
                                  return [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.formatDate(
                                            row.purchase_date ||
                                              row.purchaseDate
                                          )
                                        ) +
                                        " "
                                    ),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _c("el-table-column", {
                            attrs: { label: "Product", "min-width": "140" },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function ({ row }) {
                                  return [
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.displayProduct(row)) +
                                        " "
                                    ),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _c("el-table-column", {
                            attrs: { label: "Type", width: "90" },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function ({ row }) {
                                  return [
                                    _c(
                                      "el-tag",
                                      {
                                        attrs: {
                                          size: "mini",
                                          type: _vm.getPurchaseTypeTag(
                                            row.purchase_type ||
                                              row.purchaseType
                                          ),
                                        },
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              row.purchase_type ||
                                                row.purchaseType ||
                                                "N/A"
                                            ) +
                                            " "
                                        ),
                                      ]
                                    ),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _c("el-table-column", {
                            attrs: {
                              label: "Platform",
                              width: "80",
                              align: "center",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function ({ row }) {
                                  return [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          row.platform === "ios"
                                            ? "iOS"
                                            : "Android"
                                        ) +
                                        " "
                                    ),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _c("el-table-column", {
                            attrs: {
                              label: "Price",
                              width: "80",
                              align: "right",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function ({ row }) {
                                  return [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          row.price_amount || row.priceAmount
                                            ? `${
                                                row.price_amount ||
                                                row.priceAmount
                                              } ${
                                                row.price_currency ||
                                                row.priceCurrency ||
                                                ""
                                              }`
                                            : "-"
                                        ) +
                                        " "
                                    ),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _c("el-table-column", {
                            attrs: { label: "Expires", width: "100" },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function ({ row }) {
                                  return [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.formatDate(
                                            row.expires_date || row.expiresDate
                                          )
                                        ) +
                                        " "
                                    ),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _c("el-table-column", {
                            attrs: {
                              label: "Status",
                              width: "90",
                              align: "center",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function ({ row }) {
                                  return [
                                    _c(
                                      "el-tag",
                                      {
                                        attrs: {
                                          size: "mini",
                                          type: _vm.getTransactionStatusTag(
                                            row.status
                                          ),
                                        },
                                      },
                                      [_vm._v(" " + _vm._s(row.status) + " ")]
                                    ),
                                  ]
                                },
                              },
                            ]),
                          }),
                        ],
                        1
                      ),
                      _vm.userTransactions.length === 0 &&
                      !_vm.subscriptionsLoading
                        ? _c(
                            "div",
                            {
                              staticStyle: {
                                "text-align": "center",
                                padding: "20px",
                                color: "#909399",
                              },
                            },
                            [_vm._v(" No transactions found for this user ")]
                          )
                        : _vm._e(),
                      _c("h4", { staticStyle: { margin: "20px 0 10px" } }, [
                        _vm._v("Subscription Events"),
                      ]),
                      _c(
                        "el-table",
                        {
                          staticStyle: { width: "100%" },
                          attrs: {
                            data: _vm.userSubscriptionEvents,
                            border: "",
                            size: "small",
                            "default-sort": {
                              prop: "event_date",
                              order: "descending",
                            },
                          },
                        },
                        [
                          _c("el-table-column", {
                            attrs: {
                              label: "Date",
                              width: "100",
                              prop: "event_date",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function ({ row }) {
                                  return [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.formatDate(
                                            row.event_date || row.eventDate
                                          )
                                        ) +
                                        " "
                                    ),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _c("el-table-column", {
                            attrs: { label: "Event", width: "110" },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function ({ row }) {
                                  return [
                                    _c(
                                      "el-tag",
                                      {
                                        attrs: {
                                          size: "mini",
                                          type: _vm.getEventTypeTag(
                                            row.event_type || row.eventType
                                          ),
                                        },
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              row.event_type || row.eventType
                                            ) +
                                            " "
                                        ),
                                      ]
                                    ),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _c("el-table-column", {
                            attrs: { label: "Product", "min-width": "130" },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function ({ row }) {
                                  return [
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.displayProduct(row)) +
                                        " "
                                    ),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _c("el-table-column", {
                            attrs: {
                              label: "Status",
                              width: "100",
                              align: "center",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function ({ row }) {
                                  return [
                                    _c(
                                      "el-tag",
                                      {
                                        attrs: {
                                          size: "mini",
                                          type: _vm.getSubscriptionStatusType(
                                            row.status
                                          ),
                                        },
                                      },
                                      [_vm._v(" " + _vm._s(row.status) + " ")]
                                    ),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _c("el-table-column", {
                            attrs: { label: "Expires", width: "100" },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function ({ row }) {
                                  return [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.formatDate(
                                            row.expires_date || row.expiresDate
                                          )
                                        ) +
                                        " "
                                    ),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _c("el-table-column", {
                            attrs: {
                              label: "Auto-Renew",
                              width: "90",
                              align: "center",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function ({ row }) {
                                  return [
                                    row.auto_renew_status !== null &&
                                    row.auto_renew_status !== undefined
                                      ? _c(
                                          "span",
                                          [
                                            _c(
                                              "el-tag",
                                              {
                                                attrs: {
                                                  type: row.auto_renew_status
                                                    ? "success"
                                                    : "danger",
                                                  size: "mini",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      row.auto_renew_status
                                                        ? "Yes"
                                                        : "No"
                                                    ) +
                                                    " "
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        )
                                      : _c(
                                          "span",
                                          { staticStyle: { color: "#C0C4CC" } },
                                          [_vm._v("-")]
                                        ),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _c("el-table-column", {
                            attrs: { label: "Notes", "min-width": "120" },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function ({ row }) {
                                  return [
                                    _c(
                                      "span",
                                      {
                                        staticStyle: {
                                          color: "#909399",
                                          "font-size": "12px",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              row.cancellation_reason ||
                                                row.cancellationReason ||
                                                row.notes ||
                                                "-"
                                            ) +
                                            " "
                                        ),
                                      ]
                                    ),
                                  ]
                                },
                              },
                            ]),
                          }),
                        ],
                        1
                      ),
                      _vm.userSubscriptionEvents.length === 0 &&
                      !_vm.subscriptionsLoading
                        ? _c(
                            "div",
                            {
                              staticStyle: {
                                "text-align": "center",
                                padding: "20px",
                                color: "#909399",
                              },
                            },
                            [
                              _vm._v(
                                " No subscription events found for this user "
                              ),
                            ]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ]
              ),
              _c(
                "el-tab-pane",
                {
                  attrs: {
                    label: _vm.$t("userDialog.devicesTab"),
                    name: "devices",
                  },
                },
                [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "loading",
                          rawName: "v-loading",
                          value: _vm.devicesTabLoading,
                          expression: "devicesTabLoading",
                        },
                      ],
                    },
                    [
                      !_vm.devicesTabLoading &&
                      !_vm.devicesTabUserDevices.length
                        ? _c(
                            "div",
                            {
                              staticStyle: {
                                "text-align": "center",
                                padding: "30px",
                                color: "#909399",
                              },
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.$t("userDialog.noActiveDevice")) +
                                  " "
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm._l(_vm.devicesTabUserDevices, function (d) {
                        return _c(
                          "div",
                          {
                            key: d.serial_number,
                            staticClass: "user-device-card",
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "user-device-card__header" },
                              [
                                _c(
                                  "code",
                                  { staticClass: "user-device-card__serial" },
                                  [_vm._v(_vm._s(d.serial_number))]
                                ),
                                _c(
                                  "el-tag",
                                  {
                                    staticStyle: { "margin-left": "6px" },
                                    attrs: { size: "mini", type: "info" },
                                  },
                                  [_vm._v(" " + _vm._s(d.product_type) + " ")]
                                ),
                                d.installed_app_version
                                  ? _c(
                                      "span",
                                      {
                                        staticStyle: {
                                          color: "#606266",
                                          "font-size": "12px",
                                          "margin-left": "12px",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.$t("userDialog.installed")
                                            ) +
                                            " "
                                        ),
                                        _c("strong", [
                                          _vm._v(
                                            _vm._s(d.installed_app_version)
                                          ),
                                        ]),
                                        d.installed_wireless_version
                                          ? _c(
                                              "span",
                                              {
                                                staticStyle: {
                                                  color: "#909399",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  " / " +
                                                    _vm._s(
                                                      d.installed_wireless_version
                                                    ) +
                                                    " "
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                      ]
                                    )
                                  : _vm._e(),
                                d.previous_app_version
                                  ? _c(
                                      "span",
                                      {
                                        staticStyle: {
                                          color: "#909399",
                                          "font-size": "11px",
                                          "margin-left": "8px",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.$t(
                                                "userDialog.previousVersion",
                                                {
                                                  version:
                                                    d.previous_app_version,
                                                }
                                              )
                                            ) +
                                            " "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ],
                              1
                            ),
                            _c(
                              "div",
                              { staticClass: "user-device-card__lastdl" },
                              [
                                _c(
                                  "span",
                                  {
                                    staticStyle: {
                                      color: "#909399",
                                      "margin-right": "6px",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("userDialog.lastDownloadedOta")
                                      )
                                    ),
                                  ]
                                ),
                                d.last_download
                                  ? [
                                      _c("strong", [
                                        _vm._v(
                                          _vm._s(
                                            d.last_download
                                              .application_version_name || "-"
                                          )
                                        ),
                                      ]),
                                      d.last_download.wireless_version_name
                                        ? _c(
                                            "span",
                                            {
                                              staticStyle: { color: "#909399" },
                                            },
                                            [
                                              _vm._v(
                                                " / " +
                                                  _vm._s(
                                                    d.last_download
                                                      .wireless_version_name
                                                  ) +
                                                  " "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                      _c(
                                        "span",
                                        {
                                          staticStyle: {
                                            color: "#c0c4cc",
                                            "margin-left": "6px",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.formatDateShort(
                                                  d.last_download.created_at
                                                )
                                              ) +
                                              " "
                                          ),
                                        ]
                                      ),
                                      d.last_download.device_serial_number ===
                                      null
                                        ? _c(
                                            "el-tag",
                                            {
                                              staticStyle: {
                                                "margin-left": "6px",
                                              },
                                              attrs: {
                                                size: "mini",
                                                type: "info",
                                                effect: "plain",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "userDialog.legacyLog"
                                                    )
                                                  ) +
                                                  " "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]
                                  : _c(
                                      "span",
                                      { staticStyle: { color: "#c0c4cc" } },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.$t("userDialog.noData"))
                                        ),
                                      ]
                                    ),
                              ],
                              2
                            ),
                            _c(
                              "div",
                              { staticStyle: { "margin-top": "8px" } },
                              [
                                _c("pin-list", {
                                  attrs: {
                                    pins: _vm.pinsForDevice(d.serial_number),
                                    "removing-key":
                                      _vm.devicesTabPinRemovingKey,
                                  },
                                  on: { remove: _vm.removePinFromDevicesTab },
                                }),
                                _c("pin-form", {
                                  key: "user-devices-" + d.serial_number,
                                  attrs: {
                                    "user-id": _vm.tempUserData.userId,
                                    "user-devices": _vm.devicesTabUserDevices,
                                    "user-pins": _vm.devicesTabAllPins,
                                    "locked-device-serial": d.serial_number,
                                    "available-ota-files":
                                      _vm.devicesTabAvailableOtaFiles,
                                    "allow-user-scope": false,
                                  },
                                  on: { saved: _vm.onDevicesTabPinSaved },
                                }),
                              ],
                              1
                            ),
                          ]
                        )
                      }),
                    ],
                    2
                  ),
                ]
              ),
              _c(
                "el-tab-pane",
                { attrs: { label: "Activity Logs", name: "logs" } },
                [
                  _c(
                    "div",
                    {
                      staticStyle: {
                        "margin-bottom": "12px",
                        display: "flex",
                        gap: "10px",
                        "align-items": "center",
                      },
                    },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "150px" },
                          attrs: { size: "small" },
                          on: { change: _vm.fetchUserLogs },
                          model: {
                            value: _vm.logHours,
                            callback: function ($$v) {
                              _vm.logHours = $$v
                            },
                            expression: "logHours",
                          },
                        },
                        [
                          _c("el-option", {
                            attrs: { value: 24, label: "Last 24 hours" },
                          }),
                          _c("el-option", {
                            attrs: { value: 72, label: "Last 3 days" },
                          }),
                          _c("el-option", {
                            attrs: { value: 168, label: "Last 7 days" },
                          }),
                          _c("el-option", {
                            attrs: { value: 720, label: "Last 30 days" },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "130px" },
                          attrs: {
                            size: "small",
                            clearable: "",
                            placeholder: "All levels",
                          },
                          on: { change: _vm.fetchUserLogs },
                          model: {
                            value: _vm.logSeverity,
                            callback: function ($$v) {
                              _vm.logSeverity = $$v
                            },
                            expression: "logSeverity",
                          },
                        },
                        [
                          _c("el-option", {
                            attrs: { value: "", label: "All levels" },
                          }),
                          _c("el-option", {
                            attrs: { value: "ERROR", label: "Errors only" },
                          }),
                          _c("el-option", {
                            attrs: { value: "WARNING", label: "Warnings+" },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: {
                            size: "small",
                            icon: "el-icon-refresh",
                            loading: _vm.logsLoading,
                          },
                          on: { click: _vm.fetchUserLogs },
                        },
                        [_vm._v("Refresh")]
                      ),
                      _c(
                        "span",
                        {
                          staticStyle: {
                            color: "#909399",
                            "font-size": "12px",
                          },
                        },
                        [_vm._v(_vm._s(_vm.userLogs.length) + " entries")]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-table",
                    {
                      directives: [
                        {
                          name: "loading",
                          rawName: "v-loading",
                          value: _vm.logsLoading,
                          expression: "logsLoading",
                        },
                      ],
                      staticStyle: { width: "100%" },
                      attrs: {
                        data: _vm.userLogs,
                        border: "",
                        fit: "",
                        size: "small",
                        "max-height": "400",
                      },
                    },
                    [
                      _c("el-table-column", {
                        attrs: { label: "Time", width: "155", align: "center" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function ({ row }) {
                              return [
                                _c(
                                  "span",
                                  { staticStyle: { "font-size": "12px" } },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.formatLogDate(row.timestamp))
                                    ),
                                  ]
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                      _c("el-table-column", {
                        attrs: { label: "Level", width: "80", align: "center" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function ({ row }) {
                              return [
                                _c(
                                  "el-tag",
                                  {
                                    attrs: {
                                      type:
                                        row.severity === "ERROR" ||
                                        row.severity === "error"
                                          ? "danger"
                                          : row.severity === "WARNING" ||
                                            row.severity === "warn"
                                          ? "warning"
                                          : "info",
                                      size: "mini",
                                    },
                                  },
                                  [_vm._v(_vm._s(row.severity))]
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                      _c("el-table-column", {
                        attrs: { label: "Message", "min-width": "250" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function ({ row }) {
                              return [
                                _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      "font-size": "12px",
                                      "word-break": "break-all",
                                    },
                                  },
                                  [
                                    row.method
                                      ? _c("strong", [
                                          _vm._v(_vm._s(row.method) + " "),
                                        ])
                                      : _vm._e(),
                                    row.url
                                      ? _c(
                                          "span",
                                          { staticStyle: { color: "#409EFF" } },
                                          [_vm._v(_vm._s(row.url) + " ")]
                                        )
                                      : _vm._e(),
                                    row.statusCode
                                      ? _c(
                                          "span",
                                          {
                                            style: {
                                              color:
                                                row.statusCode >= 400
                                                  ? "#F56C6C"
                                                  : "#67C23A",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "[" +
                                                _vm._s(row.statusCode) +
                                                "] "
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                    _c("span", [_vm._v(_vm._s(row.message))]),
                                  ]
                                ),
                                row.extra
                                  ? _c(
                                      "div",
                                      { staticStyle: { "margin-top": "4px" } },
                                      _vm._l(row.extra, function (val, key) {
                                        return _c(
                                          "el-tag",
                                          {
                                            key: key,
                                            staticStyle: { margin: "2px" },
                                            attrs: {
                                              size: "mini",
                                              type: "info",
                                              title: String(val),
                                            },
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(key) +
                                                ": " +
                                                _vm._s(
                                                  typeof val === "object"
                                                    ? JSON.stringify(
                                                        val
                                                      ).substring(0, 50)
                                                    : String(val).substring(
                                                        0,
                                                        50
                                                      )
                                                ) +
                                                " "
                                            ),
                                          ]
                                        )
                                      }),
                                      1
                                    )
                                  : _vm._e(),
                              ]
                            },
                          },
                        ]),
                      }),
                    ],
                    1
                  ),
                  !_vm.logsLoading && _vm.userLogs.length === 0
                    ? _c(
                        "div",
                        {
                          staticStyle: {
                            "text-align": "center",
                            padding: "30px",
                            color: "#909399",
                          },
                        },
                        [
                          _vm._v(
                            " No logs found for this user in the selected period. "
                          ),
                        ]
                      )
                    : _vm._e(),
                ],
                1
              ),
              _c(
                "el-tab-pane",
                {
                  attrs: {
                    label: _vm.$t("savedPlaces.tab"),
                    name: "locations",
                  },
                },
                [
                  _c(
                    "div",
                    {
                      staticStyle: {
                        "margin-bottom": "10px",
                        "text-align": "right",
                      },
                    },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { size: "small", icon: "el-icon-refresh" },
                          on: { click: _vm.fetchUserLocations },
                        },
                        [_vm._v(_vm._s(_vm.$t("savedPlaces.refresh")))]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: {
                            size: "small",
                            type: "primary",
                            icon: "el-icon-plus",
                          },
                          on: { click: _vm.openAddLocation },
                        },
                        [_vm._v(_vm._s(_vm.$t("savedPlaces.addNew")))]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-table",
                    {
                      directives: [
                        {
                          name: "loading",
                          rawName: "v-loading",
                          value: _vm.loadingLocations,
                          expression: "loadingLocations",
                        },
                      ],
                      staticStyle: { width: "100%" },
                      attrs: {
                        data: _vm.userLocations,
                        border: "",
                        size: "mini",
                      },
                    },
                    [
                      _c("el-table-column", {
                        attrs: {
                          label: _vm.$t("savedPlaces.title"),
                          prop: "title",
                          "min-width": "140",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: _vm.$t("savedPlaces.address"),
                          prop: "address",
                          "min-width": "200",
                          "show-overflow-tooltip": "",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: _vm.$t("savedPlaces.latitude"),
                          prop: "latitude",
                          width: "120",
                          align: "center",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: _vm.$t("savedPlaces.longitude"),
                          prop: "longitude",
                          width: "120",
                          align: "center",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: _vm.$t("savedPlaces.type"),
                          prop: "locationType",
                          width: "110",
                          align: "center",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: _vm.$t("savedPlaces.actions"),
                          width: "150",
                          align: "center",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function ({ row }) {
                              return [
                                _c("el-button", {
                                  attrs: {
                                    size: "mini",
                                    type: "primary",
                                    icon: "el-icon-edit",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.openEditLocation(row)
                                    },
                                  },
                                }),
                                _c("el-button", {
                                  attrs: {
                                    size: "mini",
                                    type: "danger",
                                    icon: "el-icon-delete",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.handleDeleteLocation(row)
                                    },
                                  },
                                }),
                              ]
                            },
                          },
                        ]),
                      }),
                      _c("template", { slot: "empty" }, [
                        _vm._v(_vm._s(_vm.$t("savedPlaces.empty"))),
                      ]),
                    ],
                    2
                  ),
                ],
                1
              ),
              _c(
                "el-tab-pane",
                { attrs: { label: _vm.$t("savedRoutes.tab"), name: "routes" } },
                [
                  _c(
                    "div",
                    {
                      staticStyle: {
                        "margin-bottom": "10px",
                        "text-align": "right",
                      },
                    },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: {
                            size: "small",
                            type: "success",
                            icon: "el-icon-plus",
                          },
                          on: {
                            click: function ($event) {
                              _vm.routeCreateVisible = true
                            },
                          },
                        },
                        [_vm._v(_vm._s(_vm.$t("savedRoutes.create")))]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: { size: "small", icon: "el-icon-refresh" },
                          on: { click: _vm.fetchUserRoutes },
                        },
                        [_vm._v(_vm._s(_vm.$t("savedRoutes.refresh")))]
                      ),
                    ],
                    1
                  ),
                  _c("route-form-dialog", {
                    attrs: {
                      visible: _vm.routeCreateVisible,
                      "target-user-id":
                        (_vm.tempUserData && _vm.tempUserData.userId) || "",
                    },
                    on: {
                      "update:visible": function ($event) {
                        _vm.routeCreateVisible = $event
                      },
                      saved: _vm.fetchUserRoutes,
                    },
                  }),
                  _c(
                    "el-table",
                    {
                      directives: [
                        {
                          name: "loading",
                          rawName: "v-loading",
                          value: _vm.loadingRoutes,
                          expression: "loadingRoutes",
                        },
                      ],
                      staticStyle: { width: "100%" },
                      attrs: { data: _vm.userRoutes, border: "", size: "mini" },
                    },
                    [
                      _c("el-table-column", {
                        attrs: {
                          label: _vm.$t("savedRoutes.title"),
                          prop: "title",
                          "min-width": "130",
                          "show-overflow-tooltip": "",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: _vm.$t("savedRoutes.visibility"),
                          width: "110",
                          align: "center",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function ({ row }) {
                              return [
                                _c(
                                  "el-tag",
                                  {
                                    attrs: {
                                      type:
                                        row.visibility === "public"
                                          ? "success"
                                          : "info",
                                      size: "mini",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          row.visibility === "public"
                                            ? _vm.$t(
                                                "savedRoutes.visibilityPublic"
                                              )
                                            : _vm.$t(
                                                "savedRoutes.visibilityPrivate"
                                              )
                                        ) +
                                        " "
                                    ),
                                  ]
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: _vm.$t("savedRoutes.start"),
                          prop: "startAddress",
                          "min-width": "150",
                          "show-overflow-tooltip": "",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: _vm.$t("savedRoutes.end"),
                          prop: "endAddress",
                          "min-width": "150",
                          "show-overflow-tooltip": "",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: _vm.$t("savedRoutes.distance"),
                          width: "90",
                          align: "center",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function ({ row }) {
                              return [
                                _vm._v(
                                  _vm._s(_vm.formatRouteDistance(row.distanceM))
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: _vm.$t("savedRoutes.trackPoints"),
                          prop: "trackPointCount",
                          width: "90",
                          align: "center",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          label: _vm.$t("savedRoutes.actions"),
                          width: "150",
                          align: "center",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function ({ row }) {
                              return [
                                _c("el-button", {
                                  attrs: {
                                    size: "mini",
                                    type: "primary",
                                    icon: "el-icon-edit",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.openEditRoute(row)
                                    },
                                  },
                                }),
                                _c("el-button", {
                                  attrs: {
                                    size: "mini",
                                    type: "danger",
                                    icon: "el-icon-delete",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.handleDeleteRoute(row)
                                    },
                                  },
                                }),
                              ]
                            },
                          },
                        ]),
                      }),
                      _c("template", { slot: "empty" }, [
                        _vm._v(_vm._s(_vm.$t("savedRoutes.empty"))),
                      ]),
                    ],
                    2
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _vm.dialogStatus === "update" &&
              _vm.tempUserData.userType !== "admin"
                ? _c(
                    "el-button",
                    {
                      staticStyle: { float: "left" },
                      attrs: {
                        type: "danger",
                        plain: "",
                        icon: "el-icon-delete",
                        loading: _vm.purgeLoading,
                      },
                      on: { click: _vm.handlePurgeUser },
                    },
                    [
                      _vm._v(
                        " " + _vm._s(_vm.$t("userDialog.deleteAccount")) + " "
                      ),
                    ]
                  )
                : _vm._e(),
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.dialogFormVisible = false
                    },
                  },
                },
                [_vm._v(" " + _vm._s(_vm.$t("table.cancel")) + " ")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      _vm.dialogStatus === "create"
                        ? _vm.createData()
                        : _vm.updateData()
                    },
                  },
                },
                [_vm._v(" " + _vm._s(_vm.$t("table.confirm")) + " ")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title:
              _vm.locationDialogStatus === "create"
                ? _vm.$t("savedPlaces.addNew").toString()
                : _vm.$t("savedPlaces.editPlace").toString(),
            visible: _vm.locationDialogVisible,
            "append-to-body": "",
            width: "480px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.locationDialogVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              attrs: {
                model: _vm.locationForm,
                "label-position": "left",
                "label-width": "110px",
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("savedPlaces.title") } },
                [
                  _c("el-input", {
                    attrs: {
                      placeholder: _vm.$t("savedPlaces.titlePlaceholder"),
                    },
                    model: {
                      value: _vm.locationForm.title,
                      callback: function ($$v) {
                        _vm.$set(_vm.locationForm, "title", $$v)
                      },
                      expression: "locationForm.title",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("savedPlaces.address") } },
                [
                  _c("el-input", {
                    attrs: {
                      type: "textarea",
                      rows: 2,
                      placeholder: _vm.$t("savedPlaces.address"),
                    },
                    model: {
                      value: _vm.locationForm.address,
                      callback: function ($$v) {
                        _vm.$set(_vm.locationForm, "address", $$v)
                      },
                      expression: "locationForm.address",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("savedPlaces.latitude") } },
                [
                  _c("el-input", {
                    attrs: {
                      placeholder: "41.01",
                      disabled: _vm.locationDialogStatus === "update",
                    },
                    model: {
                      value: _vm.locationForm.latitude,
                      callback: function ($$v) {
                        _vm.$set(_vm.locationForm, "latitude", _vm._n($$v))
                      },
                      expression: "locationForm.latitude",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("savedPlaces.longitude") } },
                [
                  _c("el-input", {
                    attrs: {
                      placeholder: "29.01",
                      disabled: _vm.locationDialogStatus === "update",
                    },
                    model: {
                      value: _vm.locationForm.longitude,
                      callback: function ($$v) {
                        _vm.$set(_vm.locationForm, "longitude", _vm._n($$v))
                      },
                      expression: "locationForm.longitude",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("savedPlaces.type") } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "100%" },
                      attrs: {
                        placeholder: _vm.$t("savedPlaces.type"),
                        disabled: _vm.locationDialogStatus === "update",
                      },
                      model: {
                        value: _vm.locationForm.locationType,
                        callback: function ($$v) {
                          _vm.$set(_vm.locationForm, "locationType", $$v)
                        },
                        expression: "locationForm.locationType",
                      },
                    },
                    [
                      _c("el-option", {
                        attrs: {
                          label: _vm.$t("savedPlaces.typeMyLocation"),
                          value: "mylocation",
                        },
                      }),
                      _c("el-option", {
                        attrs: {
                          label: _vm.$t("savedPlaces.typeExploration"),
                          value: "exploration",
                        },
                      }),
                      _c("el-option", {
                        attrs: {
                          label: _vm.$t("savedPlaces.typeStation"),
                          value: "station",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm.locationDialogStatus === "update"
                ? _c(
                    "div",
                    { staticStyle: { "font-size": "12px", color: "#909399" } },
                    [_vm._v(" " + _vm._s(_vm.$t("savedPlaces.editNote")) + " ")]
                  )
                : _vm._e(),
            ],
            1
          ),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.locationDialogVisible = false
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("savedPlaces.cancel")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.savingLocation },
                  on: { click: _vm.submitLocation },
                },
                [_vm._v(_vm._s(_vm.$t("savedPlaces.save")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.$t("savedRoutes.editTitle").toString(),
            visible: _vm.routeDialogVisible,
            "append-to-body": "",
            width: "480px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.routeDialogVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              attrs: {
                model: _vm.routeForm,
                "label-position": "left",
                "label-width": "110px",
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("savedRoutes.title") } },
                [
                  _c("el-input", {
                    model: {
                      value: _vm.routeForm.title,
                      callback: function ($$v) {
                        _vm.$set(_vm.routeForm, "title", $$v)
                      },
                      expression: "routeForm.title",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("savedRoutes.description") } },
                [
                  _c("el-input", {
                    attrs: { type: "textarea", rows: 2 },
                    model: {
                      value: _vm.routeForm.description,
                      callback: function ($$v) {
                        _vm.$set(_vm.routeForm, "description", $$v)
                      },
                      expression: "routeForm.description",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("savedRoutes.visibility") } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "100%" },
                      model: {
                        value: _vm.routeForm.visibility,
                        callback: function ($$v) {
                          _vm.$set(_vm.routeForm, "visibility", $$v)
                        },
                        expression: "routeForm.visibility",
                      },
                    },
                    [
                      _c("el-option", {
                        attrs: {
                          label: _vm.$t("savedRoutes.visibilityPrivate"),
                          value: "private",
                        },
                      }),
                      _c("el-option", {
                        attrs: {
                          label: _vm.$t("savedRoutes.visibilityPublic"),
                          value: "public",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.routeDialogVisible = false
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("savedRoutes.cancel")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.savingRoute },
                  on: { click: _vm.submitRoute },
                },
                [_vm._v(_vm._s(_vm.$t("savedRoutes.save")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "Grant Feature",
            visible: _vm.grantDialogVisible,
            width: "500px",
            "append-to-body": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.grantDialogVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            { attrs: { model: _vm.grantFormData, "label-width": "120px" } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "Feature", required: "" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "100%" },
                      attrs: { placeholder: "Select feature" },
                      model: {
                        value: _vm.grantFormData.featureKey,
                        callback: function ($$v) {
                          _vm.$set(_vm.grantFormData, "featureKey", $$v)
                        },
                        expression: "grantFormData.featureKey",
                      },
                    },
                    _vm._l(_vm.availableFeatures, function (feature) {
                      return _c(
                        "el-option",
                        {
                          key: feature.featureKey,
                          attrs: {
                            label: feature.name,
                            value: feature.featureKey,
                          },
                        },
                        [
                          _c("span", [_vm._v(_vm._s(feature.name))]),
                          _c(
                            "span",
                            {
                              staticStyle: {
                                float: "right",
                                color: "#909399",
                                "font-size": "12px",
                              },
                            },
                            [_vm._v(_vm._s(feature.featureKey))]
                          ),
                        ]
                      )
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "Duration Type" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.grantFormData.durationType,
                        callback: function ($$v) {
                          _vm.$set(_vm.grantFormData, "durationType", $$v)
                        },
                        expression: "grantFormData.durationType",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: "days" } }, [
                        _vm._v("Days"),
                      ]),
                      _c("el-radio", { attrs: { label: "months" } }, [
                        _vm._v("Months"),
                      ]),
                      _c("el-radio", { attrs: { label: "years" } }, [
                        _vm._v("Years"),
                      ]),
                      _c("el-radio", { attrs: { label: "unlimited" } }, [
                        _vm._v("Unlimited"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm.grantFormData.durationType !== "unlimited"
                ? _c(
                    "el-form-item",
                    { attrs: { label: "Duration" } },
                    [
                      _c("el-input-number", {
                        attrs: {
                          min: 1,
                          max:
                            _vm.grantFormData.durationType === "days"
                              ? 3650
                              : _vm.grantFormData.durationType === "months"
                              ? 120
                              : 10,
                        },
                        model: {
                          value: _vm.grantFormData.durationValue,
                          callback: function ($$v) {
                            _vm.$set(_vm.grantFormData, "durationValue", $$v)
                          },
                          expression: "grantFormData.durationValue",
                        },
                      }),
                      _c(
                        "span",
                        {
                          staticStyle: {
                            "margin-left": "10px",
                            color: "#909399",
                          },
                        },
                        [_vm._v(_vm._s(_vm.grantFormData.durationType))]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.grantDialogVisible = false
                    },
                  },
                },
                [_vm._v("Cancel")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.submitGrantFeature },
                },
                [_vm._v("Grant")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "Extend Feature Duration",
            visible: _vm.extendDialogVisible,
            width: "400px",
            "append-to-body": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.extendDialogVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            { attrs: { model: _vm.extendFormData, "label-width": "120px" } },
            [
              _c("el-form-item", { attrs: { label: "Feature" } }, [
                _c("span", [
                  _vm._v(
                    _vm._s(
                      _vm.selectedEntitlement?.feature?.name ||
                        _vm.selectedEntitlement?.feature?.featureKey
                    )
                  ),
                ]),
              ]),
              _c("el-form-item", { attrs: { label: "Current End" } }, [
                _c("span", [
                  _vm._v(
                    _vm._s(
                      _vm.selectedEntitlement?.endDate
                        ? _vm.formatDate(_vm.selectedEntitlement.endDate)
                        : "N/A"
                    )
                  ),
                ]),
              ]),
              _c(
                "el-form-item",
                { attrs: { label: "Extend By" } },
                [
                  _c("el-input-number", {
                    attrs: { min: 1 },
                    model: {
                      value: _vm.extendFormData.durationValue,
                      callback: function ($$v) {
                        _vm.$set(_vm.extendFormData, "durationValue", $$v)
                      },
                      expression: "extendFormData.durationValue",
                    },
                  }),
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "100px", "margin-left": "10px" },
                      model: {
                        value: _vm.extendFormData.durationType,
                        callback: function ($$v) {
                          _vm.$set(_vm.extendFormData, "durationType", $$v)
                        },
                        expression: "extendFormData.durationType",
                      },
                    },
                    [
                      _c("el-option", {
                        attrs: { label: "Days", value: "days" },
                      }),
                      _c("el-option", {
                        attrs: { label: "Months", value: "months" },
                      }),
                      _c("el-option", {
                        attrs: { label: "Years", value: "years" },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.extendDialogVisible = false
                    },
                  },
                },
                [_vm._v("Cancel")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.submitExtendFeature },
                },
                [_vm._v("Extend")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "Device Details",
            visible: _vm.deviceDetailVisible,
            width: "700px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.deviceDetailVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.deviceDetailLoading,
                  expression: "deviceDetailLoading",
                },
              ],
            },
            [
              _vm.deviceDetailData
                ? _c(
                    "el-descriptions",
                    { attrs: { column: 2, border: "" } },
                    [
                      _c(
                        "el-descriptions-item",
                        { attrs: { label: "Serial Number" } },
                        [
                          _c("el-tag", [
                            _vm._v(
                              _vm._s(
                                _vm.deviceDetailData.serial_number ||
                                  _vm.deviceDetailData.serialNumber
                              )
                            ),
                          ]),
                        ],
                        1
                      ),
                      _c(
                        "el-descriptions-item",
                        { attrs: { label: "Product Type" } },
                        [
                          _c(
                            "el-tag",
                            {
                              attrs: {
                                type:
                                  (_vm.deviceDetailData.product_type ||
                                    _vm.deviceDetailData.productType) === "V2"
                                    ? "success"
                                    : "primary",
                              },
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.deviceDetailData.product_type ||
                                      _vm.deviceDetailData.productType
                                  ) +
                                  " "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-descriptions-item",
                        { attrs: { label: "Purchase Type" } },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.deviceDetailData.purchase_type ||
                                _vm.deviceDetailData.purchaseType ||
                                "N/A"
                            )
                          ),
                        ]
                      ),
                      _c(
                        "el-descriptions-item",
                        { attrs: { label: "Lifecycle Status" } },
                        [
                          _c(
                            "el-tag",
                            {
                              attrs: {
                                type:
                                  (_vm.deviceDetailData.lifecycle_status ||
                                    _vm.deviceDetailData.lifecycleStatus) ===
                                  "ACTIVE"
                                    ? "success"
                                    : "warning",
                              },
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.deviceDetailData.lifecycle_status ||
                                      _vm.deviceDetailData.lifecycleStatus
                                  ) +
                                  " "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-descriptions-item",
                        { attrs: { label: "Current User", span: 2 } },
                        [
                          _vm.deviceDetailData.current_user_id ||
                          _vm.deviceDetailData.currentUserId
                            ? _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm.deviceDetailData.current_user_id ||
                                      _vm.deviceDetailData.currentUserId
                                  )
                                ),
                              ])
                            : _c(
                                "el-tag",
                                { attrs: { type: "info", size: "small" } },
                                [_vm._v("Not Connected")]
                              ),
                        ],
                        1
                      ),
                      _c(
                        "el-descriptions-item",
                        { attrs: { label: "Activation Date" } },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.formatDate(
                                _vm.deviceDetailData.activation_date ||
                                  _vm.deviceDetailData.activationDate
                              )
                            )
                          ),
                        ]
                      ),
                      _c(
                        "el-descriptions-item",
                        { attrs: { label: "Purchase Date" } },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.formatDate(
                                _vm.deviceDetailData.purchase_date ||
                                  _vm.deviceDetailData.purchaseDate
                              )
                            )
                          ),
                        ]
                      ),
                      _c(
                        "el-descriptions-item",
                        { attrs: { label: "Warranty End" } },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.formatDate(
                                _vm.deviceDetailData.warranty_end_date ||
                                  _vm.deviceDetailData.warrantyEndDate
                              )
                            )
                          ),
                        ]
                      ),
                      _c(
                        "el-descriptions-item",
                        { attrs: { label: "Zoho Order" } },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.deviceDetailData.zoho_order_id ||
                                _vm.deviceDetailData.zohoOrderId ||
                                "N/A"
                            )
                          ),
                        ]
                      ),
                      _c(
                        "el-descriptions-item",
                        { attrs: { label: "Created", span: 2 } },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.formatDate(
                                _vm.deviceDetailData.created_at ||
                                  _vm.deviceDetailData.createdAt
                              )
                            )
                          ),
                        ]
                      ),
                      _c(
                        "el-descriptions-item",
                        { attrs: { label: "Notes", span: 2 } },
                        [_vm._v(_vm._s(_vm.deviceDetailData.notes || "N/A"))]
                      ),
                    ],
                    1
                  )
                : !_vm.deviceDetailLoading
                ? _c("el-empty", { attrs: { description: "Device not found" } })
                : _vm._e(),
              _vm.deviceDetailData
                ? [
                    _c(
                      "el-divider",
                      { attrs: { "content-position": "left" } },
                      [_vm._v("Device Features")]
                    ),
                    _c(
                      "el-table",
                      {
                        directives: [
                          {
                            name: "loading",
                            rawName: "v-loading",
                            value: _vm.deviceFeaturesLoading,
                            expression: "deviceFeaturesLoading",
                          },
                        ],
                        staticStyle: { width: "100%" },
                        attrs: {
                          data: _vm.deviceFeatures,
                          border: "",
                          size: "small",
                        },
                      },
                      [
                        _c("el-table-column", {
                          attrs: { label: "Feature" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function ({ row }) {
                                  return [
                                    _vm._v(
                                      _vm._s(
                                        row.feature?.name || row.featureKey
                                      )
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            1694982170
                          ),
                        }),
                        _c("el-table-column", {
                          attrs: { label: "Duration", width: "130" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function ({ row }) {
                                  return [
                                    _vm._v(
                                      _vm._s(
                                        row.durationType === "permanent"
                                          ? "Permanent"
                                          : `${row.durationValue || ""} ${
                                              row.durationType
                                            }`
                                      )
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            3030574514
                          ),
                        }),
                        _c("el-table-column", {
                          attrs: { label: "Status", width: "100" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function ({ row }) {
                                  return [
                                    _c(
                                      "el-tag",
                                      {
                                        attrs: {
                                          type:
                                            row.endDate &&
                                            new Date(row.endDate) < new Date()
                                              ? "danger"
                                              : "success",
                                          size: "small",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              row.endDate &&
                                                new Date(row.endDate) <
                                                  new Date()
                                                ? "Expired"
                                                : "Active"
                                            ) +
                                            " "
                                        ),
                                      ]
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            2744516449
                          ),
                        }),
                        _c("el-table-column", {
                          attrs: { label: "End Date", width: "140" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function ({ row }) {
                                  return [
                                    _vm._v(
                                      _vm._s(
                                        row.endDate
                                          ? _vm.formatDate(row.endDate)
                                          : "N/A"
                                      )
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            1452421928
                          ),
                        }),
                      ],
                      1
                    ),
                    _vm.deviceFeatures.length === 0 &&
                    !_vm.deviceFeaturesLoading
                      ? _c("el-empty", {
                          attrs: {
                            description: "No features assigned",
                            "image-size": 60,
                          },
                        })
                      : _vm._e(),
                  ]
                : _vm._e(),
            ],
            2
          ),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.deviceDetailVisible = false
                    },
                  },
                },
                [_vm._v("Close")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }